<template>
  <div>
    <div
      class="content-devx"
    >
      <DxForm
        label-mode="static"
        label-location="top"
      >
        <DxGroupItem
          :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_irrigation')"
        >
          <DxGroupItem
            :col-count="2"
          >
            <DxSimpleItem
              :key="keyIrrigationConf"
              name="irrigationConfiguration"
              :data-field="
                $t('registerProject.registerProjectGreenHouse.register_project_configuration_irrigation')
              "
              editor-type="dxSelectBox"
              :editor-options="{
                items: irrigation,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.irrigation.irrigation_id,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangeIrrigationConfiguration,
                placeholder: '',
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              name="register_project_equation'"
              :data-field="$t('registerProject.registerProjectGreenHouse.register_project_equation')"
              editor-type="dxSelectBox"
              css-class="bold"
              :editor-options="{
                items: project_equation,
                value: newProject.irrigation.equation,
                onValueChanged: onChangeEquation,
                hint:
                  'Se recomienda usar la ecuación Radiación-Almeria en el sureste español y para otras ubicaciones la ecuación de Hargreaves',
                readOnly: readOnly,
                placeholder: ''
              }"
            />
          </DxGroupItem>
        </DxGroupItem>
      </DxForm>
    </div>
    <div
      class="content-devx"
    >
      <f7-row>
        <f7-col
          v-show="!readOnly"
          class="encalado"
        >
          <DxForm
            label-mode="static"
            label-location="top"
          >
            <DxGroupItem
              :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_Whitewashing')"
            >
              <DxSimpleItem
                name="whiteWashing"
                :data-field="$t('registerProject.registerProjectGreenHouse.register_project_Whitewashing')"
                editor-type="dxSelectBox"
                :editor-options="{
                  items: analysis_recient,
                  value: newProject.whiteWashingSelected,
                  onValueChanged: onChangeWhiteWashing,
                  placeholder: ''
                }"
              />
              <DxSimpleItem
                name="typeOfWhiteWashing"
                :data-field="$t('registerProject.registerProjectGreenHouse.register_project_typeOfWhiteWashing')"
                editor-type="dxSelectBox"
                :visible="visible"
                :editor-options="{
                  items: WithouWhitewashing,
                  value: typeOfWhiteWashing,
                  displayExpr: 'type',
                  valueExpr: 'id',
                  onValueChanged: onChangeTypeOfWhiteWashing,
                  placeholder: ''
                }"
              />
              <DxSimpleItem
                :key="`aplicationDate${key}`"
                name="aplitacionDate"
                :data-field="$t('registerProject.registerProjectGreenHouse.register_project_aplitacionDate')"
                editor-type="dxDateBox"
                :visible="visible"
                :editor-options="{
                  value: aplicationDate,
                  displayFormat: 'dd/MM/yyyy',
                  onValueChanged: onChangeAplitacionDate,
                  min: newProject.cultive && newProject.cultive.date_init
                    ? newProject.cultive.date_init : null,
                  max: newProject.cultive && newProject.cultive.date_end
                    ? newProject.cultive.date_end : null,
                }"
              />
              <DxSimpleItem
                name="washingDate"
                :data-field="$t('registerProject.registerProjectGreenHouse.register_project_washingDate')"
                editor-type="dxDateBox"
                :visible="visible"
                :editor-options="{
                  value: washingDate,
                  displayFormat: 'dd/MM/yyyy',
                  onValueChanged: onChangeWashingDate,
                  min: newProject.cultive && newProject.cultive.date_init
                    ? newProject.cultive.date_init : null,
                  max: newProject.cultive && newProject.cultive.date_end
                    ? newProject.cultive.date_end : null,
                }"
              />
            </DxGroupItem>
          </DxForm>
        </f7-col>
        <f7-col
          v-if="visible || whitewashed.length > 0"
          class="encalado"
          :style="!readOnly ? '' : 'width: 100%'"
        >
          <DxForm
            v-if="readOnly"
            label-mode="static"
            label-location="top"
          >
            <DxGroupItem
              :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_Whitewashing')"
            />
          </DxForm>
          <DxDataGrid
            :data-source="whitewashed"
            :show-borders="true"
            no-data-text="Sin datos"
            @row-updated="updateWhitewashed"
          >
            <DxSelection
              mode="single"
            />
            <DxStateStoring
              :enabled="true"
              type="localStorage"
              storage-key="GreenHouseParTwo"
            />
            <DxExport
              :enabled="false"
            />
            <DxEditing
              :allow-updating="!readOnly"
              :allow-deleting="!readOnly"
              :confirm-delete="true"
              mode="row"
            >
              <DxTexts
                :confirm-delete-message="$t('Confirm_Delete_Text')"
                :confirm-delete-title="$t('Confirm_Delete_Title')"
                edit-row="Editar"
                delete-row="Eliminar"
                save-row-changes="Guardar"
                cancel-row-changes="Cancelar"
                yes="OK"
              />
            </DxEditing>
            <DxPaging :page-size="10" />
            <DxPager
              :show-page-size-selector="true"
              :show-info="true"
            />
            <DxHeaderFilter :visible="true" />
            <DxSearchPanel
              text=""
              :visible="true"
              :width="200"
              :placeholder="$t('Search_placeholder')"
            />
            <DxColumnFixing :enabled="false" />
            <DxColumn
              data-field="application_date"
              editor-type="dxDateBox"
              :caption="
                $t('registerProject.registerProjectGreenHouse.register_project_aplitacionDate'
                )"
              alignment="left"
              format="dd/MM/yyyy"
              :editor-options="{
                min: newProject.cultive && newProject.cultive.date_init
                  ? newProject.cultive.date_init : null,
                max: newProject.cultive && newProject.cultive.date_end
                  ? newProject.cultive.date_end : null,
              }"
            />
            <DxColumn
              data-field="wash_date"
              editor-type="dxDateBox"
              :caption="
                $t('registerProject.registerProjectGreenHouse.register_project_washingDate')
              "
              alignment="left"
              format="dd/MM/yyyy"
              :editor-options="{
                min: newProject.cultive && newProject.cultive.date_init
                  ? newProject.cultive.date_init : null,
                max: newProject.cultive && newProject.cultive.date_end
                  ? newProject.cultive.date_end : null,
              }"
            />
            <DxColumn
              data-field="transmittance"
              :caption="
                $t('registerProject.registerProjectGreenHouse.register_project_typeOfWhiteWashing')
              "
              :allow-header-filtering="false"
              alignment="left"
            />
          </DxDataGrid>
        </f7-col>
      </f7-row>
      <f7-row
        v-show="!readOnly"
        class="row-button"
      >
        <f7-col style="display: flex; justify-content: center;">
          <f7-button
            :class="`dx-btn-success ${enabled ? '' : 'disabled'}`"
            raised
            styling-mode="contained"
            name="btnExportData"
            @click="enabled ? addToWhiteWashing() : null"
          >
            {{ $t("add") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
    <div>
      <DxForm>
        <DxGroupItem
          css-class="content-devx group"
          :caption="$t('registerProject.registerProjectOpenAir.title_groupItem_manure_application')"
          :col-count="2"
        >
          <DxSimpleItem
            :key="keyManure"
            name="manure"
            :data-field="$t('registerProject.registerProjectOpenAir.register_project_manure')"
            editor-type="dxSelectBox"
            :editor-options="{
              items: manure,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.manure ? newProject.manure.manure_id : null,
              onValueChanged: onChangeManure,
              readOnly: readOnly,
              placeholder: ''
            }"
          />
          <DxSimpleItem
            name="aplicationDate"
            :data-field="$t('registerProject.registerProjectOpenAir.register_project_aplicationDate')"
            editor-type="dxDateBox"
            :editor-options="{
              value: newProject.manure ? newProject.manure.date : null,
              displayFormat: 'dd/MM/yyyy',
              onValueChanged: onChangeAplitacionDateManure,
              max: newProject.cultive.date_init,
              readOnly: readOnly
            }"
          />

          <DxSimpleItem
            name="appliedVolumen"
            :data-field="$t('registerProject.registerProjectOpenAir.registe_project_appliedVolumen')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.manure ? newProject.manure.volume : null,
              onValueChanged: onChangeVolAplicated,
              readOnly: readOnly
            }"
          />
        </DxGroupItem>
      </DxForm>
    </div>

    <DxPopUpIrrigation />
    <DxPopUpManure v-if="selection === 'GreenHouse'" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
  DxEditing,
  DxTexts,
} from 'devextreme-vue/data-grid';
import { locale } from 'devextreme/localization';
import moment from 'moment';
import DxPopUpIrrigation from '../popUpIrrigation/index.vue';
import DxPopUpManure from '../PopUpManure/index.vue';
import EventBus from '../../../../js/event-bus';
import { DEVICE_PLATFORM } from '../../../../js/constants';

export default {

  name: 'GreenHouseTwo',
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxPopUpIrrigation,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxPopUpManure,
    DxEditing,
    DxTexts,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      whiteWashingAdded: [],
      visible: false,
      typeOfWhiteWashing: '',
      aplicationDate: '',
      washingDate: '',
      enabled: false,
      keyIrrigationConf: 0,
      keyManure: 0,
      key: 0,
      devicePlatform: DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectGreenHouse', ['newProject', 'WithouWhitewashing', 'analysis_recient', 'irrigation', 'stationClimate', 'cropMedium', 'methodPlantation', 'floor', 'analysis_recient',
      'unit', 'unitCe', 'manure', 'whitewashed', 'project_equation']),
    ...mapState('Database', ['currentProject']),
  },
  async beforeMount() {
    EventBus.$on('irrigation-conf', (id) => {
      if (id) {
        this.setIrrigationConfiguration(id);
        this.keyIrrigationConf += 1;
      }
    });
    EventBus.$on('selected-manure', (id) => {
      if (id) {
        this.setManureSelected(id);
        this.keyManure += 1;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('irrigation-conf');
    EventBus.$off('selected-manure');
  },
  created() {
    locale('es');
  },
  mounted() {
    if (this.newProject.whiteWashingSelected === 'Si') {
      this.visible = true;
    }
    if (this.newProject.irrigation && this.newProject.irrigation.et0_ecuation) {
      this.newProject.irrigation.equation = this.newProject.irrigation.et0_ecuation;
    }
    if (this.newProject.whitewashed && this.newProject.whitewashed.length) {
      const whitewashedFormat = [];
      this.newProject.whitewashed.forEach((item) => {
        whitewashedFormat.push({
          transmittance: item.transmittance,
          application_date: moment(item.application_date).toDate(),
          wash_date: moment(item.wash_date).toDate(),
        });
      });
      this.whiteWashingAdded = whitewashedFormat;
      this.setDataSourceWhiteWashingAdded(whitewashedFormat);
    }
  },
  methods: {
    validate() {
      if (this.visible
      && this.typeOfWhiteWashing
      && this.aplicationDate
      && this.washingDate) {
        this.enabled = true;
      } else {
        this.enabled = false;
      }
    },
    onChangeIrrigationConfiguration(e) {
      if (e.value === 1) {
        this.setEnabledPopUpIrrigation(true);
        this.setIrrigationConfiguration(null);
        this.keyIrrigationConf += 1;
      } else {
        this.setIrrigationConfiguration(e.value);
      }
    },
    onChangeWhiteWashing(e) {
      if (typeof e.event !== 'undefined') {
        this.setWhiteWashing(e.value);
        if (e.value === 'Si') {
          if (this.newProject.cultive.date_init) {
            this.aplicationDate = this.newProject.cultive.date_init;
            this.key += 1;
          }
          this.visible = true;
        } else {
          this.setDataSourceWhiteWashingAdded([]);
          this.typeOfWhiteWashing = '';
          this.aplicationDate = '';
          this.washingDate = '';
          this.visible = false;
        }
      }
      this.validate();
    },
    onChangeTypeOfWhiteWashing(e) {
      this.typeOfWhiteWashing = e.value;
      this.validate();
    },
    onChangeAplitacionDate(e) {
      this.aplicationDate = e.value;
      this.validate();
    },
    onChangeWashingDate(e) {
      this.washingDate = e.value;
      this.validate();
    },
    onChangeManure(e) {
      if (e.value === 1) {
        this.setEnabledPopUpManure(true);
        this.setManureSelected(null);
        this.keyManure += 1;
      } else {
        this.setManureSelected(e.value);
      }
    },
    addToWhiteWashing() {
      this.whiteWashingAdded.push({
        transmittance: this.typeOfWhiteWashing,
        application_date: moment(this.aplicationDate).toDate(),
        wash_date: moment(this.washingDate).toDate(),
      });
      this.setDataSourceWhiteWashingAdded(this.whiteWashingAdded);
      this.typeOfWhiteWashing = '';
      this.aplicationDate = '';
      this.washingDate = '';
    },
    updateWhitewashed(data) {
      this.setDataSourceWhiteWashingAdded(this.whitewashed);
    },
    onChangeCeWaterGround(e) {
      this.setCeWaterGround(e.value);
    },
    onChangeAnalysisAvailable(e) {
      // eslint-disable-next-line no-unused-expressions
      e.value === 'Si' ? this.setAnalysisAvailables(true) : this.setAnalysisAvailables(false);
      this.setAnalysisAvailables(e.value);
    },
    onChangeIrrigationFloorUnit(e) {
      this.setIrrigationFloorUnit(e.value);
    },
    onChangeAplitacionDateManure(e) {
      this.setApplicationDateManure(e.value);
    },
    onChangeVolAplicated(e) {
      this.setVolAplicated(e.value);
    },
    onChangeEquation(e) {
      this.setEquation(e.value);
    },
    ...mapActions('ProjectGreenHouse', ['setIrrigationConfiguration', 'setWhiteWashing', 'setTypeOfWhiteWashing', 'setAplitacionDate',
      'setWashingDate', 'setEnabledPopUpIrrigation', 'setEnabledPopUpManure', 'setManureSelected', 'setAnalysisAvailables',
      'setIrrigationFloorUnit', 'setApplicationDateManure', 'setVolAplicated', 'setDataSourceWhiteWashingAdded', 'setCeWaterGround',
      'setEquation']),
  },
};
</script>

<style lang="scss" scoped>
  @import "../registerProject.scss";
  @import "../../../../css/mixins";
  .encalado {
    width: 100%;
    @include md {
      width: 50%;
    }
  }
  .dx-btn-success {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .row-button {
    width: 100%;
    padding-top: 1rem;
    @include md {
      width: 50%;
      padding-top: 0;
    }
  }
</style>
